<template>
	<div class="box">
		<div class="columns is-mobile">
			<div class="column is-one-third" v-if="movie.poster">
				<figure class="media-left" style="width:100%">
					<p class="image">
						<img :src="API_LOCATION+'/storage/'+movie.poster" :alt="movie.title">
					</p>
				</figure>				
			</div>
			<div class="column">
					<h2 class="title is-5 mb-1">
						{{ movie.title }}
					</h2>
					<p class="movie-length" v-if="movie.length">
						{{ movie.length }} {{ $t('min') }}
					</p>
					<div class="movie-description mb-5" v-html="movie_information" v-if="movie_information && !movie.poster"></div>
			</div>
		</div>
		<article class="media" width="30%">

			<div class="media-content">
				<div class="content">

				</div>
			</div>
		</article>
		<div class="content">
			<rating :movie_id="movie.id" :items="items" :legend="$t('rate_this_movie')" kind="growRotate" :value="value" @change="update"></rating>
		</div>
	</div>
</template>

<script>
import Rating from './Rating'

export default{
	props: {
		movie: {
			required: true
		},
		ticket: {
			required: true
		}
	},
	components: {
		Rating
	},
	computed: {
		movie_description(){
			if(!this.movie.description){
				return null
			}
			return this.movie.description.replace('<p><br></p>', '') == '' ? null : this.movie.description
		},
		movie_information(){
			if(!this.movie.information){
				return null
			}
			return this.movie.information.replace('<p><br></p>', '') == '' ? null : this.movie.information
		}
	},
	data(){
		return {
			value: 0,
			items: [
				{ title: '10 '+this.$t('stars'), value: 10, label: 10 },
				{ title: '9 '+this.$t('stars'), value: 9, label: 9 },
				{ title: '8 '+this.$t('stars'), value: 8, label: 8 },
				{ title: '7 '+this.$t('stars'), value: 7, label: 7 },
				{ title: '6 '+this.$t('stars'), value: 6, label: 6 },
				{ title: '5 '+this.$t('stars'), value: 5, label: 5 },
				{ title: '4 '+this.$t('stars_4_3_2'), value: 4, label: 4 },
				{ title: '3 '+this.$t('stars_4_3_2'), value: 3, label: 3 },
				{ title: '2 '+this.$t('stars_4_3_2'), value: 2, label: 2 },
				{ title: '1 '+this.$t('star'), value: 1, label: 1 }
			],
			API_LOCATION: process.env.VUE_APP_API_LOCATION
		}
	},
	methods: {
		update (val) {
			if(typeof val == 'number'){
				this.$emit('setVote', { vote: val, movie_id: this.movie.id })
				this.value = val
			}
		}
	}
}
</script>

<style>
.hero-body .container .movie-description p{ color: #333333 !important; }
</style>